import { render, staticRenderFns } from "./ConfigurationItemRow.vue?vue&type=template&id=2c6e7914&scoped=true"
import script from "./ConfigurationItemRow.vue?vue&type=script&lang=js"
export * from "./ConfigurationItemRow.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationItemRow.vue?vue&type=style&index=0&id=2c6e7914&prod&scoped=true&lang=scss"
import style1 from "./ConfigurationItemRow.vue?vue&type=style&index=1&id=2c6e7914&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e7914",
  null
  
)

export default component.exports